import Image from 'next/image';
import React from 'react';
import dynamic from 'next/dynamic';
import { LOGIN_BACKGROUND_IMAGE } from '~/constants';
const Logos = dynamic(() => import('./Logos'));
type Props = {
  children?: (JSX.Element | boolean)[] | JSX.Element;
  showMascot?: boolean;
};
const IDLayout = (props: Props) => {
  const {
    children,
    showMascot = false
  } = props;
  return <div className={wrapperCss}>
      {showMascot ? <Image className={mascotCss} src="https://static.chotot.com/storage/mascot/waving_hello.png" alt="mascot" width={74} height={74} priority /> : null}

      {children}
      <Logos />

      <Image className="background-img" priority src={LOGIN_BACKGROUND_IMAGE} alt="background" fill />
    </div>;
};
const wrapperCss = "w1eil6in";
const mascotCss = "mdezdqu";
export default IDLayout;

require("./index.linaria.module.css");